
import { Outlet, Link } from "react-router-dom";
import './App.css';
import { useState, useEffect } from 'react';
import PreLoader from "./component/preLoader";



function App() {
  const wave1 = document.getElementById("wave1");
  const wave2 = document.getElementById("wave2");
  const wave3 = document.getElementById("wave3");
  const wave4 = document.getElementById("wave4");
  const animateWave = [
    {
      backgroundPositionX: "0px",
      easing: 'ease-out',
    },
    {
      backgroundPositionX: "-1000px",
      easing: 'ease-in',
    }]

  const animateWave_02 = [
    {
      backgroundPositionX: "0px",
      easing: 'ease-out',
    },
    {
      backgroundPositionX: "1100px",
      easing: 'ease-in',
    }]
  const [showMenu, setShowMenu] = useState(true);
  const handleShowMenu = () => {
    setShowMenu(!showMenu)
    wave1.animate(animateWave, 2000)
    wave2.animate(animateWave_02, 2000)
    wave3.animate(animateWave, 2000)
    wave4.animate(animateWave_02, 2000)
  }

  const [loading, setLoading] = useState(true)
  function onReady(callback) {
    var intervalID = window.setInterval(checkReady, 1000);

    function checkReady() {
        if (document.getElementsByTagName('body')[0] !== undefined) {
            window.clearInterval(intervalID);
            callback.call(this);
        }
    }
}

  onReady(function () {
    setLoading(false); 
  });

  const handleClick = () => {
    setTimeout(handleShowMenu, 1000);
  }

  useEffect(() => {
    setTimeout(() => {
      handleClick();
    }, 500);  
  }, [])
  
  if (loading) {
    return (
      <PreLoader/>
    )
  }
  return (
    <>
      <div className="App">
        <div className={`menu ${showMenu ? "active" : "inactive"}`}>
          <div className="btn-one" onClick={handleShowMenu}>
            <span >Menu</span>
          </div>
          <div className="waves">
            <div className={`wave ${showMenu ? "active1" : "inactive1"}`} id="wave1"></div>
            <div className={`wave ${showMenu ? "active2" : "inactive2"}`} id="wave2"></div>
            <div className={`wave ${showMenu ? "active1" : "inactive1"}`} id="wave3"></div>
            <div className={`wave ${showMenu ? "active2" : "inactive2"}`} id="wave4"></div>
            <div className="containerFlex">
              <div className="photoSide left"></div>
              <div className="containerGrid">
              <Link to="/" id="home" onClick={handleClick}></Link>
              <Link to="/Communication" id="communication" onClick={handleClick}></Link>
              <Link to="/Relation" id="relation" onClick={handleClick}></Link>
              <Link to="/Evenementiel" id="evenementiel" onClick={handleClick}></Link>
              <Link to="/Audit-Gestion" id="phototheque" onClick={handleClick}></Link>
              </div>
              <div className="photoSide right"></div>
            </div>
          </div>
          <div className="footer">
            <span className="spacefirst">  </span>
            <Link to="/References" onClick={handleClick} id="contact_link"><span>Références</span></Link>
            <span className="space">    </span>
            <Link to="/Contact" onClick={handleClick} id="contact_link" ><span>Contact</span></Link>
            <span className="space">    </span>
            <span>By Lucas Beckers</span>
          </div>
        </div>
        <Outlet></Outlet>
        <PreLoader/>
      </div>
    </>
  );
}

export default App;
